import { createAction, props } from '@ngrx/store';
export const collapseNote = createAction('[Notes modal] Collapse Note', props());
export const expandNote = createAction('[Notes modal] Expand Note', props());
export const deleteNote = createAction('[Notes modal] Delete Note', props());
export const fetchNotes = createAction('[Notes modal] Fetch Notes');
export const saveNote = createAction('[Notes modal] Save Note', props());
export const setNotesFetchSuccess = createAction('[Notes modal] Set Notes Fetch Success Message', props());
export const setNotesFetchFailure = createAction('[Notes modal] Set Notes Fetch Failure Message', props());
export const setSelectedNote = createAction('[Notes modal] Set Selected Note', props());
export const updateNote = createAction('[Notes modal] Update Note', props());
